import React, { useState } from 'react';

export default function PdfDownloads() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email) return;
    setSubmitted(true);
  };

  return (
    <div className="bg-[#141c2e] border border-slate-800 rounded-2xl p-6 md:p-8 my-8 shadow-2xl">
      <div className="flex items-center gap-3 mb-3">
        <span className="text-3xl">📄</span>
        <h2 className="text-2xl font-black text-white">Kostenlose LAP Spickzettel & Formelsammlungen</h2>
      </div>
      <p className="text-slate-400 text-sm mb-6">
        Hole dir die wichtigsten Zusammenfassungen, Formeln und Merksätze als kompaktes PDF direkt in dein Postfach.
      </p>

      {submitted ? (
        <div className="bg-[#22c55e]/10 border border-[#22c55e] text-[#22c55e] p-4 rounded-xl font-bold text-center">
          ✓ Vielen Dank! Wir haben dir den Download-Link an <strong>{email}</strong> gesendet.
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3">
          <input
            type="email"
            required
            placeholder="Deine E-Mail-Adresse für den Download..."
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="flex-1 bg-[#0b1329] border border-slate-700 text-white p-3.5 rounded-xl font-semibold outline-none focus:border-[#fbbf24]"
          />
          <button
            type="submit"
            className="bg-[#fbbf24] hover:bg-[#f59e0b] text-[#0f172a] font-black px-6 py-3.5 rounded-xl transition-colors whitespace-nowrap cursor-pointer"
          >
            PDF Spickzettel anfordern →
          </button>
        </form>
      )}
    </div>
  );
}
